import React, { Component } from 'react';
import * as Colors from '../../utils/Color';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const styles = {
    menuItemStyle: {
        padding: '8px 0'
    },
    floatingLabelStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    underlineStyle: {
        borderColor: Colors.grey
    },
    iconStyle: {
        fill: Colors.grey50
    },
    selectedMenuItemStyle: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight: '700'
    }
};


class SelectMenu extends Component {
    render() {
        const { menu, name, floatingLabelText, onChange, value, error } = this.props;
        const options = { errorText: error, floatingLabelText, name, value, onChange: (e, k, v) => onChange(name, v) };
        return (
            <SelectField
                {...options}
                fullWidth
                menuItemStyle={styles.menuItemStyle}
                underlineStyle={styles.underlineStyle}
                underlineFocusStyle={styles.underlineStyle}
                iconStyle={styles.iconStyle}
                floatingLabelStyle={styles.floatingLabelStyle}
                selectedMenuItemStyle={styles.selectedMenuItemStyle} >

                { menu.map(item => <MenuItem key={item.value} value={item.value} primaryText={ item.key } />) }

            </SelectField>
        );
    }
}

export default SelectMenu;



// WEBPACK FOOTER //
// ./src/components/UI/Select-f.js